import { TLocale } from "@rsonav/shared-config";
import { ERequestType } from "@rsonav/protocol";

export const requestTypes: { [key in ERequestType]: { localeKey: keyof TLocale; iconClass: string } } = {
	[ERequestType.Littered]: { localeKey: "support_requestTypeLittered", iconClass: "garbage" },
	[ERequestType.Overfilled]: { localeKey: "support_requestTypeOverfilled", iconClass: "container" },
	[ERequestType.Add]: { localeKey: "support_requestTypeAdd", iconClass: "home" },
	[ERequestType.Other]: { localeKey: "support_requestTypeOther", iconClass: "msg" },
};
